import { AfterViewInit, Component, OnDestroy, OnInit, inject } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { SafeResourceUrl } from '@angular/platform-browser';
import { TranslateModule } from '@ngx-translate/core';
import { ChildWindow, ChildWindowBuilderService, WindowTarget } from '../../../embedding/child.service';
import { fillTemplateWithData } from '../../routines';
import { AbstractCallComponent } from '../abstract-call/abstract-call.component';

@Component({
    selector: 'se-tab-window-call',
    templateUrl: './tab-window-call-component.component.html',
    styleUrls: ['../call-style/call.scss'],
    imports: [TranslateModule, MatButtonModule],
    standalone: true,
})
export class TabWindowCallComponentComponent extends AbstractCallComponent implements OnInit, OnDestroy, AfterViewInit {
    private readonly childWindowService = inject(ChildWindowBuilderService);
    url: SafeResourceUrl | null = null;
    tabWindow: ChildWindow | null = null;

    ngOnInit(): void {
        super.ngOnInit();
        this.openWindow();
    }

    openWindow = async () => {
        const url = this.parseUrlWithData();
        this.tabWindow = await this.childWindowService.withUrl(url).withTarget(WindowTarget.Blank).open();
    };

    ngAfterViewInit(): void {
        if (this.url) this.showLoading.set(true);
    }

    ngOnDestroy() {
        if (this.tabWindow) this.tabWindow.close();
    }

    parseUrlWithData = (): string => {
        if (!this.call.url) return '';
        if (this.dataStore) {
            return fillTemplateWithData(this.dataStore, this.call.placeholders, this.call.url);
        } else {
            return this.call.url;
        }
    };

    onCloseChildWindow() {
        if (this.tabWindow) this.tabWindow.close();
        this.close();
    }

    close(): void {
        this.end();
    }
}
